export default __webpack_public_path__ + "static/media/clearperspective-logo.90fc2344.png";